import { useState } from 'react';

export default function ContactCTA() {
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');
  const formUrl = 'http://ihua3.com/';

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('company_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      form.reset();
      return;
    }

    formData.delete('company_alt');

    try {
      const response = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        setFormStatus('error');
        setFormError(serverMsg || '提交失败，请稍后重试');
      }
    } catch {
      setFormStatus('error');
      setFormError('网络错误，请检查连接后重试');
    }
  };

  return (
    <section className="flex flex-col lg:flex-row min-h-[500px]">
      <div className="lg:w-1/2 relative overflow-hidden bg-accent-100/60">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20studio%20workspace%2C%20creative%20team%20working%20environment%2C%20warm%20lighting%2C%20digital%20art%20tablets%2C%20webtoon%20production%20scene%2C%20cozy%20atmosphere%2C%20illustration%20studio%2C%20modern%20creative%20office&width=800&height=700&seq=contact-cta-01&orientation=landscape"
          alt="联系我们 - 韩漫漫画网"
          title="韩漫漫画网 - 商务合作"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute top-6 left-6">
          <span className="text-xs text-foreground-600 font-medium bg-background-50/80 px-3 py-1 rounded-full whitespace-nowrap">
            商务合作
          </span>
        </div>
        <div className="absolute bottom-8 left-6">
          <h3 className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight whitespace-nowrap">
            期待与<br />您合作
          </h3>
        </div>
      </div>

      <div className="lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-8 md:px-16 py-14">
        <h3 className="text-3xl md:text-5xl font-bold font-heading text-foreground-900 text-center leading-tight mb-6 whitespace-nowrap">
          联系我们
        </h3>
        <p className="text-sm md:text-base text-foreground-600 text-center max-w-md leading-relaxed mb-8">
          如果您有商务合作需求、内容授权事宜或任何其他问题，欢迎通过以下方式联系我们。
          我们的团队将在1-2个工作日内回复您的消息。
        </p>
        <div className="flex flex-col gap-3 mb-8 w-full max-w-md">
          <div className="flex items-center gap-3 p-3 rounded-lg bg-background-100">
            <div className="w-10 h-10 flex items-center justify-center text-primary-500">
              <i className="ri-mail-line text-lg"></i>
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground-900 whitespace-nowrap">商务邮箱</p>
              <p className="text-sm text-foreground-600 whitespace-nowrap">hello@ihua3.com</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-background-100">
            <div className="w-10 h-10 flex items-center justify-center text-primary-500">
              <i className="ri-phone-line text-lg"></i>
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground-900 whitespace-nowrap">客服热线</p>
              <p className="text-sm text-foreground-600 whitespace-nowrap">400-888-6688</p>
            </div>
          </div>
          <div className="flex items-center gap-3 p-3 rounded-lg bg-background-100">
            <div className="w-10 h-10 flex items-center justify-center text-primary-500">
              <i className="ri-map-pin-line text-lg"></i>
            </div>
            <div>
              <p className="text-xs font-semibold text-foreground-900 whitespace-nowrap">公司地址</p>
              <p className="text-sm text-foreground-600 whitespace-nowrap">北京市朝阳区望京SOHO T1栋B座1208室</p>
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="w-full max-w-md">
          <input
            type="text"
            name="company_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="antispam-field"
          />
          <div className="flex flex-col gap-3">
            <input
              type="text"
              name="name"
              placeholder="您的姓名"
              required
              className="w-full px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors duration-200"
            />
            <input
              type="email"
              name="email"
              placeholder="您的邮箱"
              required
              className="w-full px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors duration-200"
            />
            <textarea
              name="message"
              placeholder="请输入您的留言（500字以内）"
              rows={4}
              maxLength={500}
              className="w-full px-4 py-3 rounded-lg bg-background-100 border border-background-200/70 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors duration-200 resize-none"
            ></textarea>
            <button
              type="submit"
              className="px-6 py-3 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer flex items-center justify-center gap-2"
            >
              发送消息
              <i className="ri-send-plane-line"></i>
            </button>
          </div>

          {formStatus === 'success' && (
            <p className="mt-4 text-sm text-green-600 text-center">消息已成功发送，我们会尽快回复！</p>
          )}
          {formStatus === 'error' && (
            <p className="mt-4 text-sm text-red-500 text-center">{formError}</p>
          )}
        </form>
      </div>
    </section>
  );
}